import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./CreateLink.module.css";
import { Button } from "@commonwealthdevelopment/web-ui-component-library";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Header, Body, LinkCopy } from "../../components";
import { toast } from "react-toastify";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";

const schema = yup.object({
  notes: yup.string(),
  prospectName: yup.string().required(),
});

export const CreateLink = () => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema), mode: "onBlur" });
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState();
  const [expiresAt, setExpiresAt] = useState(2);
  const { error, execute } = useFetchWithMsal();

  const onSubmit = async (data) => {
    setIsLoading(true);
    const response = await toast.promise(
      execute("POST", "AccessLinks/create", {
        expiresAt: expiresAt,
        ...data,
      }),
      {
        pending: {
          render() {
            setIsLoading(false);
            return "Saving new Authentication Link";
          },
        },
        success: {
          render({ data }) {
            setIsLoading(false);
            return `Authentication link generated successfully`;
          },
          icon: "🟢",
        },
        error: {
          render({ data }) {
            Object.keys(data.message).forEach((key) =>
              setError(key, {
                type: "server",
                message: data.message[key],
              })
            );
            setIsLoading(false);
            return "An error ocurred during the creation of the Authentication Link";
          },
        },
      }
    );
    setData(response);
  };

  return (
    <>
      <Header>
        <h1>Generate Authentication Link</h1>
      </Header>
      <Body>
        {data ? (
          <div className={styles.createdsucess}>
            <p>
              Your new login link was generated successfully. It will expire at
              <strong> {data.expireAt} </strong>
            </p>
            <LinkCopy link={data.link} />
          </div>
        ) : (
          <form onSubmit={handleSubmit(onSubmit)}>
            <label className="form-label">The link will expire in:</label>
            <div className={`${styles.expireButtons} ${styles.formgroup}`}>
              <Button
                automationId="story_button"
                onClick={() => setExpiresAt(0)}
                variant={expiresAt === 0 ? "primary" : "secondary"}
              >
                1 Day
              </Button>
              <Button
                automationId="story_button"
                onClick={() => setExpiresAt(1)}
                variant={expiresAt === 1 ? "primary" : "secondary"}
              >
                1 Week
              </Button>
              <Button
                automationId="story_button"
                onClick={() => setExpiresAt(2)}
                variant={expiresAt === 2 ? "primary" : "secondary"}
              >
                1 Month
              </Button>
            </div>

            <div style={{ width: "40vw" }} className={styles.formgroup}>
              <label htmlFor="notes" className="form-label">
                Notes
              </label>

              <textarea
                id="notes"
                className="form-control"
                {...register("notes")}
              />
            </div>

            <div style={{ width: "40vw" }} className={styles.formgroup}>
              <label htmlFor="prospectName">Affiliate Name</label>
              <input
                id="prospectName"
                className="form-control"
                {...register("prospectName")}
              />
              {errors.prospectName?.message && (
                <p className="validationError">
                  {errors.prospectName?.message}
                </p>
              )}
            </div>

            <div className={styles.formgroup}>
              <Button
                type="submit"
                automationId="story_button"
                disabled={isLoading}
              >
                {isLoading
                  ? "Generating Authentication Link..."
                  : "Generate Authentication Link"}
              </Button>
            </div>
          </form>
        )}

        <div className={styles.footerlinks}>
          <Link to="/links">Back to Links</Link>
        </div>
      </Body>
    </>
  );
};
